import {PERIOD_TYPES} from 'config/constants/period';

const
    FIRST_DAY = 1,
    LAST_DAY = 0,
    SUM_MONTH = 1;

const
    HOURS = 12,
    MINUTES = 0,
    SECONDS = 0;

const getNow = dateNow => {
    const date = new Date(dateNow);

    date.setHours(HOURS);
    date.setMinutes(MINUTES);
    date.setSeconds(SECONDS);

    return date.getTime();

};

const _getStartDate = timestamp => {
    const date = new Date(timestamp);

    date.setHours(HOURS);
    date.setMinutes(MINUTES);
    date.setSeconds(SECONDS);

    date.setDate(FIRST_DAY);

    return date.getTime();
};

const _getEndDate = timestamp => {
    const date = new Date(timestamp);

    date.setHours(HOURS);
    date.setMinutes(MINUTES);
    date.setSeconds(SECONDS);

    date.setMonth(date.getMonth() + SUM_MONTH);
    date.setDate(LAST_DAY);

    return date.getTime();
};

const _getInnerState = date => ({
    date,
    startDate: _getStartDate(date),
    endDate:   _getEndDate(date),
    type:      PERIOD_TYPES.PERIOD_TYPE_MONTH
});
const _getInitialState = date => ({
    dashboard:      _getInnerState(date),
    reports:        _getInnerState(date),
    backups:        _getInnerState(date),
    p200:           _getInnerState(date),
    internetAccess: _getInnerState(date),
    cloudBilling:   _getInnerState(date),
    monitoring:     _getInnerState(date),
    storage:        _getInnerState(date),
    cmdb:           _getInnerState(date),
    iaas:           _getInnerState(date),
    itsm:           _getInnerState(date)
});

export const CHANGE_PERIOD = 'CHANGE_PERIOD';

export const changePeriod = (section, value) => ({
    type: CHANGE_PERIOD,
    section, value
});
export const _changePeriod = (state, {section, value}) => {
    const inner = state[section];

    if (inner.type === PERIOD_TYPES.PERIOD_TYPE_MONTH) {
        return {
            ...state,
            [section]: {
                ...state[section],
                startDate: _getStartDate(value),
                endDate:   _getEndDate(value)
            }
        };
    } else if (inner.type === PERIOD_TYPES.PERIOD_TYPE_DATE) {
        return {
            ...state,
            [section]: {
                ...state[section],
                date: value
            }
        };
    }

    return state;
};

export const CHANGE_PERIOD_TYPE = 'CHANGE_PERIOD_TYPE';

export const changePeriodType = (section, periodType) => ({
    type: CHANGE_PERIOD_TYPE,
    section, periodType
});

export const reducer = (state = _getInitialState(getNow(Date.now())), action = {}) => {
    switch (action.type) {
    case CHANGE_PERIOD:
        return _changePeriod(state, action);
    case CHANGE_PERIOD_TYPE:
        return {
            ...state,
            [action.section]: {
                ...state[action.section],
                type: action.periodType
            }
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/period.js